fc2.init({
    readMoreLink: "https://gesica-2.vingtcinq.me/mentions-legales/",
    readMoreLabel: "En savoir plus",
    banner: {
        title: "Gestion des cookies",
        description: "Ce site utilise des cookies pour améliorer votre expérience sur le site.",
        acceptAllLabel: "Tout accepter",
        customizeLabel: "Paramétrer"
    },
    modal: {
        title: "Gestion des cookies",
        description: "Certaines fonctionnalités de ce site (partage de contenu sur les réseaux sociaux, vidéos intégrées) nécessitent l'utilisation d'un service tierce. Ces fonctionnalités déposent des cookies autorisant ces sites à traquer votre navigation. Ces cookies sont uniquement déposés si vous y consentez. Vous pouvez les accepter/refuser globalement ou individuellement.",
        acceptAllLabel: "Tout accepter",
        submitLabel: "Confirmer"
    },
    sections: [{
        title: "Analytics",
        services: [{
            title: "Google Analytics",
            description: "Google Analytics nous permet d'effectuer des analyses de trafic sur le site",
            key: "gan"
        }]
    }]
});

fc2.onAccept('gan', function (data) {
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', 'UA-167315458-1');
})

fc2.onDecline('gan', function (data) {
    console.log('You declined', data)
})